import { gql, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import { Select } from "components/base/Form";

const FETCH_ODOO_PRODUCT_CATEGORIES = gql`
  query FETCH_ODOO_PRODUCT_CATEGORIES($instance: String!, $refresh: Boolean) {
    odooProductCategories(instance: $instance, refresh: $refresh) {
      id
      displayName
    }
  }
`;

const OdooProductCategorySelector = ({ instance, value, onChange }) => {
  const { loading, error, data, refetch } = useQuery(
    FETCH_ODOO_PRODUCT_CATEGORIES,
    {
      variables: { instance, refresh: false },
      notifyOnNetworkStatusChange: true,
    },
  );

  function refresh() {
    refetch({ instance, refresh: true });
  }

  return (
    <div className="flex items-center space-x-4">
      <Select
        className="w-full"
        value={value || "0"}
        onChange={(e) => onChange(e.target.value)}
        loading={loading}
        error={error}
      >
        {data && (
          <>
            <option value="0" disabled>
              Select a Category
            </option>
            {data.odooProductCategories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                #{cat.id}. {cat.displayName}
              </option>
            ))}
          </>
        )}
      </Select>
      <Button onClick={refresh} loading={loading} refresh>
        Refresh
      </Button>
    </div>
  );
};

export default OdooProductCategorySelector;
